import React, {forwardRef, Suspense} from "react"
import {reactLazyRetry} from "../../utilities/retryImport"

const MaskInputComponent = reactLazyRetry(() => import("./MaskInput"))

export const MaskInput = forwardRef<any, any>((props, ref) => (
    <Suspense fallback={null}>
        <MaskInputComponent {...props} ref={ref} />
    </Suspense>
))
